import { ToastActionType, ShowToastAction, HideToastAction } from "./types";

/**
 * Action creators for toast state management
 */
export const toastActions = {
    /**
     * Show a delayed action toast with the provided props
     */
    showToast: (payload: ShowToastAction["payload"]): ShowToastAction => ({
        type: ToastActionType.SHOW_TOAST,
        payload,
    }),

    /**
     * Hide the current toast
     */
    hideToast: (): HideToastAction => ({
        type: ToastActionType.HIDE_TOAST,
    }),
};
